import { PostDataWithIdsAsStrings, EntityWithIdAsString, PreProcessedEntity } from '@/types/postData';
import { ScheduledGeoCampaignResult } from '@/types/i-request-results';
import { SchedulerRawAttachedPricingProductsData } from '@/types/pricing';
import CookieHandler from '@/plugins/cookie-handler';
import store from '@/store';

class SchedulerRequestsHandler {
	private get baseUrl(): string {
		return store.getters.schedulerUrl();
	}

	private get campaignId(): string {
		const id = store.getters.campaignId();
		return id.toString();
	}

	public async retrieveTargetingSettingsFromScheduler(): Promise<PostDataWithIdsAsStrings> {
		const options = {
			method: 'GET',
			headers: {
				Authorization: CookieHandler.retrieveTokenIdCookie()
			}
		};

		const response = await fetch(
			`${this.baseUrl}/retrieve-start-by-campaign-id?campaignID=${this.campaignId}`,
			options
		);
		if (!response.ok) {
			throw new Error('Something went wrong while retrieving campaign settings using the Scheduler.');
		}

		const result = (await response.json()) as ScheduledGeoCampaignResult;
		const studies = this.convertFormatOfEntities(result.scheduledGeoCampaign.studies);
		const organisations = this.convertFormatOfEntities(result.scheduledGeoCampaign.organisations);
		return {
			campaign_id: parseInt(result.scheduledGeoCampaign.campaignID),
			expiry_date: result.scheduledGeoCampaign.expiryDate,
			update_date: result.scheduledGeoCampaign.updateDate,
			studies,
			organisations
		};
	}

	public async retrieveRawAttachedPricingProductsData(): Promise<SchedulerRawAttachedPricingProductsData> {
		const options = {
			method: 'GET',
			headers: {
				Authorization: CookieHandler.retrieveTokenIdCookie()
			}
		};

		const response = await fetch(
			`${this.baseUrl}/pricing?campaignID=${this.campaignId}`,
			options
		);
		if (!response.ok) {
			throw new Error('Something went wrong while retrieving pricing data using the Scheduler.');
		}

		return (await response.json()) as SchedulerRawAttachedPricingProductsData;
	}

	public shouldChangesGoThroughScheduler(): boolean {
		const startDate = store.state.campaignStartDate;
		return startDate > Date.now() / 1000;
	}

	private convertFormatOfEntities(entities: PreProcessedEntity[]): EntityWithIdAsString[] {
		return entities.map((entity) => ({
			id: entity.id,
			targeted_countries: entity.targetedCountries
		}));
	}
}

export default new SchedulerRequestsHandler();
